export default __webpack_public_path__ + "static/media/multi-point.5eda3cad.png";